import React, { useState, useEffect, useRef } from 'react';
import styles from "./styles/newtodo.module.css";
import ManageProjects from './components/manageprojects';
import { Tab, TabList, Tabs } from '@mui/joy';
import TodoTable from './components/table';
import { getFetch } from '../../../../fetch/fetch';
import { reorderTaskBySyncApi } from './components/function';

// 시설 관리 페이지 - 본사직원페이지 TODO 시스템(todo_* 테이블)을 category="facility"로 재사용
const FacilityMain: React.FC<any> = (props: any) => {

    const [projects, setProjects] = useState<any>([]);
    const [menu, setMenu] = useState<any>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [update, setUpdate] = useState<number>(0);

    useEffect(() => {

        props.activateMenuList("check");

    }, []);

    useEffect(() => {

        if (!props.user) return;

        getTodoistData();

    }, [props.user, update, props.newTodoistDataUpdate]);

    //연달아 재조회할 때 앞선 요청의 응답이 늦게 도착해 최신 데이터를 덮어쓰지 않도록 마지막 요청만 반영
    const todoistRequestSeqRef = useRef(0);

    const getTodoistData = async () => {

        const seq = ++todoistRequestSeqRef.current;

        try {

            const result: any = await getFetch("/dashboard/todoist/todoistData?category=facility");

            if (seq !== todoistRequestSeqRef.current) return;

            console.log(result.data);

            setProjects([...result.data]);

        } catch (e) {
            console.log(e);
        }

    }

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    const moveTaskToTop = async (taskId: number) => {

        console.log("moveTaskToTop");
        console.log(taskId);

        const newProjects = [...projects];

        const items: any = [];

        newProjects.forEach((project: any) => {

            project.sections.forEach((section: any) => {

                const task = section.tasks.find((task: any) => task.id === taskId);

                if (!task) return;

                const currentIndex = section.tasks.indexOf(task);

                if (currentIndex === 0) return;

                section.tasks.splice(currentIndex, 1);
                section.tasks.unshift(task);

                section.tasks.forEach((task: any, index: number) => {

                    const child_order = index + 1;

                    const oneRow: any = {};

                    oneRow.id = task.v2_id;
                    oneRow.child_order = child_order;

                    items.push(oneRow);

                })

            });

        });

        setProjects([...newProjects]);

        try {

            if (!props.user) return;

            await reorderTaskBySyncApi("item_reorder", items);

        } catch (e) {
            console.log(e);
        }

    }

    const addNoteToTask = async (projectV2Id: string, sectionV2Id: string | undefined, taskV2Id: string, note: any) => {

        console.log("addNoteToTask");

        const NewProjects = [...projects];

        NewProjects.forEach((project: any) => {
            if (project.v2_id !== projectV2Id) return;

            project.sections.forEach((section: any) => {

                if (sectionV2Id && section.v2_id !== sectionV2Id) return;

                section.tasks.forEach((task: any) => {

                    if (task.v2_id === taskV2Id) {
                        if (task.notes) {
                            task.notes.push(note);
                            return;
                        }
                    }

                    if (!task.subTasks) return;

                    task.subTasks.forEach((subTask: any) => {
                        if (subTask.v2_id === taskV2Id) {

                            if (subTask.notes) {
                                subTask.notes.push(note);
                                return;
                            }
                        }

                        if (!subTask.subTasks) return;

                        subTask.subTasks.forEach((subSubTask: any) => {
                            if (subSubTask.v2_id === taskV2Id) {

                                if (subSubTask.notes) {
                                    subSubTask.notes.push(note);
                                    return;
                                }
                            }
                        })
                    })

                })

            })

        })

        setProjects([...NewProjects]);

    }


    //댓글 읽음: 해당 task 의 모든 댓글 readUser 에 본인 추가 (useTodoProjects.markNotesRead 와 동일)
    const markNotesRead = (projectV2Id: string, sectionV2Id: string | undefined, taskV2Id: string, userId: number, userName: string) => {

        const apply = (task: any) => {
            if (task.v2_id !== taskV2Id || !Array.isArray(task.notes)) return;
            task.notes = task.notes.map((note: any) => {
                const readUser: any[] = Array.isArray(note.readUser) ? note.readUser : [];
                if (readUser.some((id: any) => `${id}` === `${userId}`)) return note;
                const readUserName: string[] = Array.isArray(note.readUserName) ? [...note.readUserName, userName] : [userName];
                return { ...note, readUser: [...readUser, userId], readUserName, readUserNameText: readUserName.join(" / ") };
            });
        };

        const NewProjects = [...projects];

        NewProjects.forEach((project: any) => {
            if (project.v2_id !== projectV2Id) return;
            project.sections.forEach((section: any) => {
                if (sectionV2Id && section.v2_id !== sectionV2Id) return;
                section.tasks.forEach((task: any) => {
                    apply(task);
                    (task.subTasks || []).forEach((subTask: any) => {
                        apply(subTask);
                        (subTask.subTasks || []).forEach((subSubTask: any) => apply(subSubTask));
                    });
                });
            });
        });

        setProjects([...NewProjects]);

    }

    return (
        <div className={styles.main}>

            <Tabs aria-label="Basic tabs" defaultValue={0} sx={{
                width: "1750px",
                backgroundColor: "transparent"
            }}
                onChange={(e: any, value: any) =>
                    setMenu(value)
                }
            >
                <TabList
                >
                    <Tab>시설 관리 TODO</Tab>
                    <Tab>프로젝트/섹션 관리</Tab>
                </TabList>
            </Tabs>

            {
                menu === 0 ?
                    <TodoTable projects={projects}
                        loading={loading}
                        apiKey={props.user ? "todo" : ""}
                        letsUpdate={letsUpdate}
                        moveTaskToTop={moveTaskToTop}
                        userName={props.user ? props.user.name : ""}
                        addNoteToTask={addNoteToTask}
                        markNotesRead={markNotesRead}
                        user={props.user}
                        hideNotice={true}
                        title="시설 관리 TODO"
                        showManager={true}
                    />
                    :
                    ""
            }

            {
                menu === 1 ?
                    <ManageProjects
                        projects={projects}
                        letsUpdate={letsUpdate}
                        category="facility"
                    />
                    :
                    ""
            }

        </div>
    )
}

export default FacilityMain;
